import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faCaretRight,
  faCaretDown,
  faChevronCircleRight,
  faChevronCircleLeft,
  faShoppingCart,
  faArrowCircleRight,
  faArrowCircleLeft,
  faTrash,
  faUser,
  faTruck,
  faComment,
  faEuroSign,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faCaretRight,
  faCaretDown,
  faChevronCircleRight,
  faChevronCircleLeft,
  faShoppingCart,
  faArrowCircleRight,
  faArrowCircleLeft,
  faTrash,
  faUser,
  faTruck,
  faComment,
  faEuroSign,
  faInfoCircle
)

Vue.component('fa', FontAwesomeIcon)
